"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  padding: 0;\n  height: auto;\n  & div {\n    padding: 0;\n  }\n  &:focus {\n    outline: none;\n    text-decoration-line: underline;\n    color: ", ";\n  }\n  &:not([data-focus-visible-added]) {\n    background: transparent;\n    outline: none;\n    color: ", ";\n  }\n\n  &:active {\n    outline: 0;\n    opacity: 1.0 !important;\n    color: ", ";\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: transparent;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var Button_1 = require("./Button");

exports.LinkButton = styled_components_1.default(Button_1.Button)(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.bodyStyle3;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.focus;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.tertiary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.focus;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.disabled;
});